import { styled } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

interface EmptyProductListProps {
  areThereAnyFetchedProducts: boolean;
  searchFieldState?: string;
}

export default function EmptyProductList({ areThereAnyFetchedProducts, searchFieldState }: EmptyProductListProps) {
  const { t } = useTranslation('productLibrary');
  return areThereAnyFetchedProducts ? ( // if true it means that products are fetched but did not pass the filtering
    <EmptyProductListMessage data-testid="no-filtered-products">
      <Trans i18nKey="search.notFound" t={t} components={{ searchTerm: <Bold>{searchFieldState}</Bold> }} />
    </EmptyProductListMessage>
  ) : (
    <EmptyProductListMessage data-testid="no-products-product-list">{t('search.notAvailable')}</EmptyProductListMessage>
  );
}

const EmptyProductListMessage = styled('div')`
  text-align: center;
  margin-top: 3rem;
`;

const Bold = styled('span')`
  font-weight: bold;
  font-size: 1.25rem;
`;
